import {
  INTERNATIONAL_CHOICE_QUERY,
  INTERNATIONAL_PAGE_PATH,
  SITE_ROOT_PATH,
  UAE_PAGE_PATH,
  type SiteMarket,
} from '~/constants/market';
import { stripLocalePrefix } from '~/utils/i18n/locale';

/** Analytics `page` of a landing: /uae, /international, the Hebrew International (/he…) or / (every other path). */
export type LandingPage = '/' | '/he' | '/international' | '/uae';

const LANDING_PATHS: readonly string[] = [SITE_ROOT_PATH, INTERNATIONAL_PAGE_PATH, UAE_PAGE_PATH];

// Locale prefix, query/hash and trailing slash removed.
const normalizeLandingPath = (path: string): string =>
  stripLocalePrefix(path.split(/[?#]/)[0] || SITE_ROOT_PATH).replace(/(.)\/$/, '$1');

/** The market landings: /, /international and /uae, with any locale prefix. */
export const isLandingPath = (path: string): boolean => LANDING_PATHS.includes(normalizeLandingPath(path));

export const resolveLandingPage = (path: string): LandingPage => {
  const page = normalizeLandingPath(path);
  if (page === UAE_PAGE_PATH) return '/uae';
  if (path === '/he' || path.startsWith('/he/')) return '/he';
  return page === INTERNATIONAL_PAGE_PATH ? '/international' : '/';
};

/** Low-prominence footer link to the other market's page. */
export const crossMarketFooterLink = (track: SiteMarket): { labelKey: string; href: string } =>
  track === 'uae'
    ? {
        labelKey: 'landing.uae.footer.internationalLink',
        href: `${INTERNATIONAL_PAGE_PATH}?${INTERNATIONAL_CHOICE_QUERY}`,
      }
    : { labelKey: 'landing.footer.uaeLink', href: UAE_PAGE_PATH };
